import { render, staticRenderFns } from "./contractors.vue?vue&type=template&id=2a11224f&"
import script from "./contractors.vue?vue&type=script&lang=js&"
export * from "./contractors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports